import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function ConsultingLayout({ children }) {
  const { pathname } = useLocation();

  const isActive = (path) => {
    if (path === "/consulting") {
      return pathname === "/consulting";
    }

    return pathname.startsWith(path);
  };

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    const prevHtmlBg = html.style.background;
    const prevBodyBg = body.style.background;
    const prevBodyMargin = body.style.margin;

    html.style.background = "#030407";
    body.style.background = "#030407";
    body.style.margin = "0";

    return () => {
      html.style.background = prevHtmlBg;
      body.style.background = prevBodyBg;
      body.style.margin = prevBodyMargin;
    };
  }, []);

  return (
    <div style={styles.shell}>
      <div style={styles.bgGlowA} aria-hidden="true" />
      <div style={styles.bgGlowB} aria-hidden="true" />

      <div style={styles.container}>
        <header style={styles.headerWrap}>
          <div style={styles.header}>
            <div style={styles.brand}>
              <div style={styles.logo}>HDC</div>

              <div>
                <div style={styles.title}>HDC Consulting</div>
                <div style={styles.tag}>Digital Solutions</div>
              </div>
            </div>

            <nav style={styles.nav}>
              <Link
                style={{
                  ...styles.link,
                  ...(isActive("/consulting") ? styles.active : {}),
                }}
                to="/consulting"
              >
                Accueil
              </Link>

              <Link
                style={{
                  ...styles.link,
                  ...(isActive("/consulting/services")
                    ? styles.active
                    : {}),
                }}
                to="/consulting/services"
              >
                Services
              </Link>

              <Link
                style={{
                  ...styles.link,
                  ...(isActive("/consulting/finance")
                    ? styles.activeFinance
                    : styles.financeLink),
                }}
                to="/consulting/finance"
              >
                <span style={styles.financeIcon}>💳</span>
                Financement
              </Link>

              <Link
                style={{
                  ...styles.link,
                  ...(isActive("/consulting/a-propos")
                    ? styles.active
                    : {}),
                }}
                to="/consulting/a-propos"
              >
                À propos
              </Link>

              <Link
                style={{
                  ...styles.link,
                  ...(isActive("/consulting/contact")
                    ? styles.active
                    : {}),
                }}
                to="/consulting/contact"
              >
                Contact
              </Link>

              <Link to="/" style={styles.cta}>
                Retour Groupe
              </Link>
            </nav>
          </div>
        </header>

        <main style={styles.main}>{children}</main>

        
      </div>
    </div>
  );
}

const styles = {
  shell: {
    minHeight: "100vh",
    width: "100%",
    background: "#030407",
    color: "#f1f5f9",
    overflowX: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },

  bgGlowA: {
    position: "fixed",
    inset: 0,
    background:
      "radial-gradient(900px 600px at 15% 10%, rgba(99,102,241,0.18), transparent 55%)",
    pointerEvents: "none",
    zIndex: 0,
  },

  bgGlowB: {
    position: "fixed",
    inset: 0,
    background:
      "radial-gradient(800px 600px at 85% 20%, rgba(168,85,247,0.14), transparent 60%)",
    pointerEvents: "none",
    zIndex: 0,
  },

  container: {
    width: "min(1200px, calc(100% - 32px))",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },

  headerWrap: {
    position: "fixed",
    top: "14px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "min(1200px, calc(100% - 32px))",
    zIndex: 50,
  },

  header: {
    width: "100%",
    padding: "14px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    borderRadius: "18px",
    background:
      "linear-gradient(90deg, rgba(11,16,32,0.88), rgba(18,10,43,0.88))",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 18px 50px rgba(0,0,0,0.35)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    position: "relative",
    zIndex: 1,
  },

  brand: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  logo: {
    width: 44,
    height: 44,
    borderRadius: 16,
    display: "grid",
    placeItems: "center",
    fontWeight: 900,
    letterSpacing: 0.5,
    background: "rgba(99,102,241,0.22)",
    border: "1px solid rgba(255,255,255,0.18)",
    boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.05)",
  },

  title: {
    fontWeight: 900,
    lineHeight: 1.05,
    fontSize: 18,
  },

  tag: {
    fontSize: 12,
    opacity: 0.75,
  },

  nav: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },

  link: {
    color: "rgba(255,255,255,0.88)",
    textDecoration: "none",
    fontWeight: 800,
    padding: "8px 10px",
    borderRadius: 10,
    transition: "all .15s ease",
    border: "1px solid transparent",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    whiteSpace: "nowrap",
  },

  active: {
    color: "#ffffff",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.10)",
  },

  financeLink: {
    color: "#c4b5fd",
    background: "rgba(124,58,237,0.08)",
    border: "1px solid rgba(167,139,250,0.18)",
  },

  activeFinance: {
    color: "#ffffff",
    background:
      "linear-gradient(135deg, rgba(124,58,237,0.34), rgba(37,99,235,0.26))",
    border: "1px solid rgba(167,139,250,0.40)",
    boxShadow: "0 8px 24px rgba(99,102,241,0.18)",
  },

  financeIcon: {
    fontSize: "15px",
    lineHeight: 1,
  },

  cta: {
    textDecoration: "none",
    fontWeight: 900,
    color: "#0b1020",
    background: "linear-gradient(90deg, #a855f7, #6366f1)",
    padding: "10px 14px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.18)",
    boxShadow: "0 12px 26px rgba(99,102,241,0.20)",
    whiteSpace: "nowrap",
  },

  main: {
    width: "100%",
    padding: "96px 0 56px",
    position: "relative",
    zIndex: 1,
    flex: 1,
  },

  footer: {
    width: "100%",
    marginTop: "auto",
    padding: "14px 18px",
    borderRadius: "14px",
    textAlign: "center",
    background: "rgba(30, 41, 59, 0.6)",
    border: "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
  },

  footerText: {
    margin: 0,
    color: "#94a3b8",
    fontSize: "13px",
    fontWeight: "500",
    fontFamily: "'Inter', sans-serif",
    letterSpacing: "0.02em",
  },
};